<template>
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M13.1173 3.73553L14.2483 3.01218C13.8814 2.55361 13.4652 2.13601 13.0075 1.76758L11.9116 2.60919C12.3583 2.93396 12.7637 3.31218 13.1173 3.73553Z"
			:fill="color"
		/>
		<path
			d="M14.1524 5.43915L15.43 5.0415C15.2325 4.54704 14.9871 4.07695 14.6996 3.63672L13.5757 4.35579C13.7993 4.69664 13.9935 5.05865 14.1524 5.43915H14.1524Z"
			:fill="color"
		/>
		<path
			d="M7.99993 14.6648C4.32484 14.6648 1.33546 11.6752 1.33546 7.99994C1.33546 4.32481 4.32501 1.33541 7.99993 1.33541C9.16859 1.33541 10.2671 1.63863 11.2232 2.16887L12.3586 1.29684C11.1037 0.477982 9.60693 0 7.99989 0C3.58869 0 0 3.58872 0 7.99997C0 12.4112 3.58869 15.9999 7.99989 15.9999C11.0886 15.9999 13.7722 14.2393 15.1046 11.6703H13.5591C12.3649 13.4728 10.3196 14.6648 7.99996 14.6648L7.99993 14.6648Z"
			:fill="color"
		/>
		<path
			d="M14.6646 7.99927H15.9999C15.9999 7.87766 15.9961 7.75685 15.9907 7.63672H14.6543C14.661 7.75686 14.6646 7.87753 14.6646 7.99927H14.6646Z"
			:fill="color"
		/>
		<path
			d="M14.5678 6.86884H15.9192C15.8657 6.49182 15.7854 6.12378 15.681 5.76562L14.4062 6.16246C14.4723 6.39309 14.5266 6.62869 14.5677 6.86884H14.5678Z"
			:fill="color"
		/>
	</svg>
</template>

<script>
export default {
	props: {
		color: {
			type: String,
			default: 'white',
		},
	},
};
</script>
